<template>
  <v-dialog v-model="open" width="fit-content">
    <template #activator="dialogActivatorSlotProps">
      <slot
        v-bind="{
          open: dialogActivatorSlotProps.on.click,
          props: { ...dialogActivatorSlotProps.attrs, class: 'cursor-pointer' },
        }"
      >
      </slot>
    </template>

    <v-card width="460" elevation="6">
      <v-card-title class="d-flex flex-row justify-space-between">
        <v-img
          src="https://kintsu-public.s3.amazonaws.com/logos-v2/Bioplanner_notagline_svg.svg"
          max-width="30%"
        ></v-img>
        <span class="caption">v{{ $root.appVersion }}</span></v-card-title
      >
      <v-card-text>Software de gestão de atendimento médico personalizado.</v-card-text>
      <v-card-text>&copy; 2025 Kintsu All Rights Reserved</v-card-text>

      <v-card-text>
        <strong>KINTSU - CONEXÃO QUE TRANSFORMA</strong>
        <br />
        CNPJ: 40.716.172/0001-80 <br />
        +55 11 99893-3332<br />

        suporte@kintsu.com.br</v-card-text
      >

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" :href="termsLink" target="_blank" @click="close" :disabled="!termsLink"
          >termos de uso</v-btn
        >
        <v-btn text color="primary" @click="close">fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: authGettersMap } = createNamespacedHelpers('auth')
export default {
  computed: {},
  data() {
    return {
      termsLink: null,
      open: false,
    }
  },
  computed: {
    ...authGettersMap(['isPhysician', 'pharmaceuticalDomainConfig', 'pharmaceuticalId']),
    complementaryText() {
      return this.isPhysician ? 'a HCPs' : 'ao público leigo'
    },
  },
  methods: {
    close() {
      this.open = false
    },
    async getTermLinks() {
      try {
        const { value } = await this.$api.getParameter('PHARMACEUTICAL_TERM_COMPONENT')
        this.termsLink = value
      } catch (error) {
        this.$root.error(
          'Não foi possível carregar os termos de uso, tente novamente mais tarde',
          'Ops, algo deu errado',
        )
      }
    },
  },
}
</script>
<style scoped></style>
